function ShowSelectedImage({ newimageone, color }) {
    return (
        <div className="preview-min-height preview-image-background">
            <img src={newimageone} className={`img card-custom ${color ? "" : "filter-0"} image-preview mt-3 mb-3 `} />
        </div>
    );
}

export default ShowSelectedImage